<div class="left-container">
    <app-button
        [text]="'mimic.button.back'"
        [translateParams]="{
            vesselName: vessel.name,
            vesselNumber: vessel.number,
        }"
        [noneButtonPadding]="true"
        [variant]="BUTTON_TEXT"
        [iconButton]="true"
        icon="arrow-circle"
        customFontSize="16px"
        customFontColor="var(--functional-white-0)"
        customFontWeight="500"
        (onClick)="backButtonClick()"></app-button>
</div>
<div class="center-container" [class.disabled]="!userCanEdit">
    <mat-icon class="icon-pointer" (click)="undo()" svgIcon="undo"></mat-icon>
    <mat-icon class="icon-pointer" (click)="redo()" svgIcon="redo"></mat-icon>
</div>
<div class="right-container" [class.lowOpacity]="!selectedMimic?.id">
    <div class="autosave-container" [class.lowOpacity]="!this.userCanEdit">
        <div class="autosave-status" *ngIf="isAutosaveEnabled" [ngClass]="{ save_error: hasSaveError() }">
            <div *ngIf="hasSaveError()" class="save-error-icon" alt="save-error-icon"></div>
            <mat-icon *ngIf="!hasSaveError()" [svgIcon]="getAutosaveIcon()" class="autosave-icon" />
            <div>
                {{ getAutosaveStatus() | translate: { time: lastSaveTime } }}
            </div>
        </div>
        <ng-container *ngIf="hasSaveError()">
            <div class="save-error-button" (click)="openErrorMessage()">
                {{ 'mimic.header.autosave.error.button' | translate }}
            </div>
        </ng-container>
        <div class="autosave-title">
            <ng-container *ngIf="isAutosaveEnabled">
                {{ 'mimic.header.autosave.enabled.title' | translate }}
            </ng-container>
            <ng-container *ngIf="!isAutosaveEnabled">
                {{ 'mimic.header.autosave.disabled.title' | translate }}
            </ng-container>
        </div>
        <mat-slide-toggle
            class="autosave-toggle"
            [checked]="isAutosaveEnabled"
            (change)="updateAutosave($event)"
            [disabled]="!this.userCanEdit">
        </mat-slide-toggle>
    </div>
    <app-zoom-range></app-zoom-range>
    <app-button
        text="mimic.button.preview"
        [noneButtonPadding]="true"
        [variant]="BUTTON_TEXT"
        [iconButton]="true"
        icon="preview"
        customFontSize="16px"
        customFontColor="var(--functional-white-0)"
        customFontWeight="500"
        (onClick)="previewMimic()"></app-button>
    <app-button
        [text]="'mimic.page.save-mimic.button'"
        [disable]="!selectedMimic?.name || mimicNameIsRepeated || !userCanEdit"
        (onClick)="saveMimic()"
        [size]="BUTTON_SMALL_SIZE"></app-button>
</div>
